module.exports = __webpack_public_path__ + "static/media/View-Join-Pods.30c94d79.svg";